import { Divider } from 'antd'
import React from 'react'
import { PageTitleH1, PageTitleWrap } from '../../styles/global';
import { ProfileOutlined } from '@ant-design/icons';

type PageTitleType = {
    text: any;
    icon?: any;
}

const PageTitle = ({ text, icon = <ProfileOutlined style={{ fontSize: '24px', color: '#42A5F5' }} /> }: PageTitleType) => {
    return (
        <Divider plain>
            <PageTitleWrap>
                {icon}
                <PageTitleH1>{text}</PageTitleH1>
            </PageTitleWrap>
        </Divider>
    )
}

export default PageTitle